module.exports = __webpack_public_path__ + "static/img/ma05.9f1f94b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/works/photographing/ma05.jpg
// module id = 6hNx
// module chunks = 0